export default {
  namespaced: true,
  state: {
    hasAddedNewBookmark: false
  },
  getters: {},
  mutations: {
    setHasAddedNewBookmark(state, payload) {
      state.hasAddedNewBookmark = payload;
    }
  },
  actions: {}
};
